enum AvailabilityDefaultParameters {
  MAX_AVAILABILITIES_DATE_RANGE = 62,
}

export { AvailabilityDefaultParameters }
